document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.scroll-video-section');
  if (!section) return;

  const wrapper = section.querySelector('.scroll-video-wrapper');
  const video = section.querySelector('video.scroll-video');
  const desktop = section.dataset.desktopVideo;
  const mobile = section.dataset.mobileVideo || desktop;
  const mql = window.matchMedia('(max-width: 749px)');
  let duration;

  function loadSrc() {
    const src = mql.matches ? mobile : desktop;
    if (video.src !== src) {
      video.src = src;
      video.load();
    }
  }

  function createScrollTrigger() {
    // Define throttling variables here
    let lastUpdate = 0;
    const updateInterval = 50; // Update every 50ms

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom top',
      scrub: 0.3,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: self => {
        const now = performance.now();
        if (now - lastUpdate > updateInterval) {
          video.currentTime = self.progress * duration;
          lastUpdate = now;
        }
      }
    });
  }

  video.addEventListener('loadedmetadata', () => {
    duration = video.duration;

    function updateHeight() {
      const w = wrapper.clientWidth;
      const h = (video.videoHeight / video.videoWidth) * w;
      wrapper.style.height = `${h}px`;
    }
    updateHeight();
    window.addEventListener('resize', updateHeight);
    mql.addEventListener('change', () => {
      loadSrc();
      updateHeight();
      ScrollTrigger.refresh();
    });

    if (video.readyState >= 4) {
      createScrollTrigger();
    } else {
      video.addEventListener('canplaythrough', createScrollTrigger, { once: true });
    }
  });

  loadSrc();
});